let publishedLanguages;
const getLanguages =()=>{
    return JSON.parse(localStorage.getItem('adminStore'))?.website.languages?.list || [];
}


publishedLanguages = getLanguages();

const getLocaleData = (data,langCode) => {
    publishedLanguages = getLanguages();
    const transLang = publishedLanguages.find(lang => lang.code == langCode);
    if(data){
        const localeData = data.find(trans => trans.languageID == transLang.id)
        return localeData
    }else{
        return {}
    }
};
const setTranslateKeys = (data) => {
    publishedLanguages = getLanguages();
    const dataToTranslate = [];
    for (let index = 0; index < publishedLanguages.length; index++) {
        const element = publishedLanguages[index];
        dataToTranslate.push({
            languageID:element.id,
            ...data
        })
    }
    return dataToTranslate
};
const setTranslateRules = (data) => {
    
    const rules = {};
    const languageRules = [];
    publishedLanguages = getLanguages();
    for (let ruleIndex = 0; ruleIndex < data.length; ruleIndex++) {
        const element = data[ruleIndex];
        rules[element] = [];
        rules[element].push(
            {
                required:true,
                trigger:'blur',
                message:'required field'
            }
        );
    }
    for (let index = 0; index < publishedLanguages.length; index++) {
        languageRules.push(rules)
    }
    return languageRules
};
const filterPublishedTranslates = (data) => {
    publishedLanguages = getLanguages();
    let publishedTranslates = [];
    if (data){
        for (let index = 0; index < publishedLanguages.length; index++) {
            const element = publishedLanguages[index];
            const languageName = data.find(translate => translate.languageID == element.id);
            publishedTranslates.push(languageName)
        }
        publishedTranslates.sort((a,b) =>{
            if ( a.languageID < b.languageID ){
                return 1;
            }
            if ( a.languageID > b.languageID ){
                return -1;
            }
            return 0;
        })
    }else{
        publishedTranslates = data
    }
    return publishedTranslates
};
const getLanguageName = (data) => {
    publishedLanguages = getLanguages();
    const languageName = publishedLanguages.find(lang => lang.id == data);
    // if(languageName){
    // }
    return languageName?.name || 'err'
};
const getImage = (imagePath) => {
    if(!imagePath.includes('blob')) {

        return process.env.VUE_APP_IMAGES_PATH + imagePath
    }else{
        return imagePath
    }

};
const getOrderName = (i) => {
    var j = i % 10,
    k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
};
export {
    getLocaleData,
    setTranslateKeys,
    getLanguageName,
    setTranslateRules,
    filterPublishedTranslates,
    getOrderName,
    getImage,
}